export default "__VITE_ASSET__CPjEqKCl__"